import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0b6f25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "servePeo" }
const _hoisted_2 = { class: "search_div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "职务：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "区域：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("设置服务区域")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("人员同步")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subs" }, "区域信息请前往包厢设置中编辑，服务员需关联服务区域后，才可服务于该区域", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "服务人员" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_input, {
          modelValue: $setup.names,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.names) = $event)),
          size: "default",
          class: "search_input"
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_el_select, {
          modelValue: $setup.jobs,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.jobs) = $event)),
          clearable: "",
          placeholder: "请选择角色名称"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_5,
        _createVNode(_component_el_select, {
          modelValue: $setup.areas,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.areas) = $event)),
          clearable: "",
          placeholder: "请选择角色名称"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.areaList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.getPersonLists()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showArea()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.syncs
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: $setup.tableData,
        border: "",
        style: {"width":"100%"},
        "header-row-class-name": "tb_bg",
        onSelectionChange: $setup.selectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "人员姓名"
          }),
          _createVNode(_component_el_table_column, {
            prop: "station_name",
            label: "职务"
          }),
          _createVNode(_component_el_table_column, {
            prop: "area_name",
            label: "服务区域"
          })
        ]),
        _: 1
      }, 8, ["data", "onSelectionChange"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: $setup.areaDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.areaDialog) = $event)),
      title: "设置服务区域",
      width: "400px",
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.areaDialog=false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "120px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "设置服务区域" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "设置人员" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checkPeo, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index>0?'，':'') + _toDisplayString(item.name), 1))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "设置区域" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: $setup.checkArea,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.checkArea) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.areaList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        label: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: $setup.formClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: $setup.closeDia }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}